import '../css/logo.css';
import '../css/fonts.css';
import { SubHeader } from './subHeader';

const NOTE_ENABLED = process.env.REACT_APP_FEATURE_NOTE === 'true';
const NOTE_TEXT = process.env.REACT_APP_NOTE_TEXT || '';

export function MainContent() {
    return (
        <main className="content">
            <h1 id="title">Kribba</h1>
            {NOTE_ENABLED && (
                <div id='sh-center'>
                    {SubHeader(NOTE_TEXT)}
                </div>
            )}
        </main>
    );
}
